import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://hahamanhua.com';

const pageMeta: Record<string, { title: string; description: string; keywords: string; ogType?: string }> = {
  '/': {
    title: '韩国漫画-好看的韩国漫画-哈哈漫画网',
    description: '哈哈漫画网为您推荐好看的韩国漫画，海量资源免费阅读，让您轻松找到心仪的作品。恋爱、动作、奇幻、悬疑、搞笑等多种类型，每日同步更新。',
    keywords: '韩国漫画,好看的韩国漫画,哈哈漫画网,免费阅读,在线漫画',
  },
  '/about': {
    title: '关于我们 - 哈哈漫画网',
    description: '哈哈漫画网专注韩国漫画在线阅读，成立于2020年，与多家韩国漫画平台合作，提供正版优质阅读体验。了解我们的品牌故事、用户口碑和联系方式。',
    keywords: '哈哈漫画网,韩国漫画网站,在线漫画平台,关于我们',
  },
};

function getCategoryMeta(slug: string) {
  const categoryMap: Record<string, string> = {
    'all': '全部漫画',
    'romance': '恋爱漫画',
    'action': '动作漫画',
    'fantasy': '奇幻漫画',
    'mystery': '悬疑漫画',
    'comedy': '搞笑漫画',
    'slice-of-life': '日常漫画',
    'drama': '剧情漫画',
    'horror': '恐怖漫画',
    'bl-gl': 'BL/GL漫画',
  };
  const name = categoryMap[slug] || '分类漫画';
  return {
    title: `${name} - 哈哈漫画网`,
    description: `哈哈漫画网为您精选${name}，海量优质韩国漫画免费在线阅读。每日更新，高清画质，流畅阅读体验。`,
    keywords: `${name},韩国漫画,哈哈漫画网,免费阅读,在线漫画`,
  };
}

const defaultSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '哈哈漫画网',
  url: BASE_URL,
  description: '哈哈漫画网为您推荐好看的韩国漫画，海量资源免费阅读',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${BASE_URL}/category/all?search={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '哈哈漫画网',
  url: BASE_URL,
  description: '专注韩国漫画在线阅读，海量优质漫画资源免费看',
};

export default function Layout({ children }: { children: React.ReactNode }) {
  const location = useLocation();

  useEffect(() => {
    let meta = pageMeta[location.pathname];

    if (!meta) {
      if (location.pathname.startsWith('/category/')) {
        const slug = location.pathname.split('/').pop() || 'all';
        meta = getCategoryMeta(slug);
      } else if (location.pathname.startsWith('/article/')) {
        meta = {
          title: '漫画详情 - 哈哈漫画网',
          description: '哈哈漫画网漫画详情页，查看漫画信息、章节列表，在线免费阅读韩国漫画。',
          keywords: '韩国漫画,漫画详情,哈哈漫画网,免费阅读',
          ogType: 'article',
        };
      } else {
        meta = pageMeta['/'];
      }
    }

    document.title = meta.title;

    const setMetaTag = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMetaTag('description', meta.description);
    setMetaTag('keywords', meta.keywords);
    setMetaTag('og:title', meta.title, true);
    setMetaTag('og:description', meta.description, true);
    setMetaTag('og:url', `${BASE_URL}${location.pathname}`, true);
    setMetaTag('og:type', meta.ogType || 'website', true);
    setMetaTag('twitter:title', meta.title);
    setMetaTag('twitter:description', meta.description);

    const linkEl = document.querySelector('link[rel="canonical"]');
    if (linkEl) {
      linkEl.setAttribute('href', `${BASE_URL}${location.pathname}`);
    }
  }, [location]);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(defaultSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      {children}
    </>
  );
}